import React, { useState } from "react";

const categories = [
    {
        id: 0,
        title: "Présentation plateforme",
    },
];

const videos = [
    {
        id: 1,
        title: "Présentation application",
        category: 0,
        url: "https://www.youtube.com/embed/xzbZLzLvl7A?si=09_jRHZkHQsKsjZ_",
        thumbnail: "https://img.youtube.com/vi/xzbZLzLvl7A/hqdefault.jpg",
    },
];

export const Bibliothèque = () => {
    const [selectedVideo, setSelectedVideo] = useState(null);

    return (
        <div className="flex flex-col md:flex-row h-full md:h-screen">
            {/* Section Vidéos */}
            <div className="w-full md:w-3/4 overflow-y-auto">
                {categories.map((category) => (
                    <div key={category.id}>
                        <h4 className="m-4 text-xl font-semibold">
                            {category.title}
                        </h4>
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 p-4">
                            {videos.map((video) => (
                                <div
                                    key={video.id}
                                    className="cursor-pointer text-center"
                                    onClick={() => setSelectedVideo(video)}
                                >
                                    <img
                                        src={video.thumbnail}
                                        alt={video.title}
                                        className="w-full rounded-lg shadow-md hover:opacity-80 transition-opacity"
                                    />
                                    <p className="mt-2 text-sm">
                                        {video.title}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}

                {/* Modale vidéo */}
                {selectedVideo && (
                    <div
                        className="fixed inset-0 flex items-center justify-center bg-black/50 z-50 p-4"
                        onClick={() => setSelectedVideo(null)}
                    >
                        <div
                            className="bg-white p-4 rounded-lg w-full max-w-4xl"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="relative pb-[56.25%] h-0">
                                <iframe
                                    src={selectedVideo.url}
                                    title={selectedVideo.title}
                                    frameBorder="0"
                                    allowFullScreen
                                    className="absolute top-0 left-0 w-full h-full rounded-md"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Section Contact */}
            <div className="w-full md:w-1/4 bg-white p-6 border-t md:border-t-0 md:border-l border-gray-300">
                <h2 className="text-2xl font-bold mb-4">Contact</h2>
                <p>
                    <strong>Nom :</strong> Jean Dupont
                </p>
                <p>
                    <strong>Email :</strong> jean@example.com
                </p>
                <p>
                    <strong>Téléphone :</strong> 06 00 00 00 00
                </p>
                <div className="mt-4">
                    <p>
                        <strong>Adresse :</strong>
                    </p>
                    <p>123 Rue de l’exemple</p>
                    <p>69000 Lyon</p>
                </div>
            </div>
        </div>
    );
};
